import '@babel/polyfill';
import 'react-app-polyfill/ie9';
import './assets/scss/index.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';

import { configureStore } from './redux/store';
import { registerAxiosInterceptors } from './commons/http/axios';
import { configureReactIntlPolyfill } from './commons/i18n/intl';

import App from './App/App';
import UseTheme from './commons/components/UseTheme';

function renderApp(store, history) {
	ReactDOM.render(
		<Provider store={store}>
			<UseTheme>
				<App history={history} />
			</UseTheme>
		</Provider>,
		document.querySelector('#root')
	);
}

function startApp() {
	const history = createBrowserHistory({ basename: process.env.PUBLIC_URL });
	const store = configureStore(history);

	registerAxiosInterceptors(store);

	configureReactIntlPolyfill(() => {
		renderApp(store, history);
	});
}

startApp();
